/* eslint-disable no-useless-escape */
/* eslint-disable react-hooks/exhaustive-deps */
import { BrowserRouter as Router } from "react-router-dom";
import { Suspense, useEffect, useState } from "react";
import Main from "./routes/main/Main";
import Loader from "./components/common/layout/Loader";
import { useDispatch, useSelector } from "react-redux";
import { getApp } from "./shared/utils/helpers";
import CacheBuster from 'react-cache-buster';
import app from '../package.json';
import OtherWebLink from "./components/common/layout/OtherWebLink";
import useAxios from "./shared/hooks/use-axios";
import { url } from "./shared/utils/url";
import { dataActions } from "./shared/store/dataSlice";
import { authActions } from "./shared/store/auth-Slice";
import UX4GAccessibilityWidget from "./components/common/layout/Ux4gaccessibilitywidget ";
// import { uiActions } from "./shared/store/ui-Slice";

const MainRouter = () => {
  const theme: any = useSelector((state: any) => state.ui.theme);
  const webOpen: boolean = useSelector((state: any) => state.data.webOpen);
  const isLogin: boolean = useSelector((state: any) => state.auth.isLogin);
  let [loader, setLoader] = useState<any>(true);
  const [tenantData, setTenantData] = useState<any[]>([]);
  const Components: any = !loader && getApp(tenantData);
  const dispatch = useDispatch();

  useEffect(() => {
    if (webOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [webOpen]);

  useEffect(() => {
    if (theme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }

    !!theme && localStorage.setItem("theme", theme);
  }, [theme]);

  const getTenant = () => {
    // for tenant setting
    setTenantData([{
      subdomain: window.location.hostname,
      app: Main,
      main: true
    }]);
    setLoader(false);
  };

  useEffect(() => {
    getTenant();
  }, []);

  const getMenu = async () => {
    try {
      dispatch(dataActions.setHeaderMenuData(null));
      const res: any = await useAxios.get(`/en${url?.menus}header-menu/`);

      if (res && res?.status === 200) {
        dispatch(dataActions.setHeaderMenuData(res?.data));
      }
    } catch (error) {
      dispatch(dataActions.setHeaderMenuData([]))
      console.error("error while feching header menu", error);
    }
  };

  useEffect(() => {
    getMenu();
  }, []);

  const getProfile = async () => {
    try {
      const res: any = await useAxios.get(url?.me);

      if (res && res?.status === 200) {
        dispatch(authActions.userDetail(res?.data?.data));
      }
    } catch (error) {
      console.error("error while feching profile detail", error);
    }
  };

  useEffect(() => {
    isLogin && getProfile();
  }, [isLogin]);

  // const getCurrentGoogleTranslateLang = () => {
  //   const match = document.cookie.match(/(^|;) ?googtrans=\/[^\/]+\/([^;]+)/);
  //   dispatch(uiActions.changeLang(match ? match[2] : 'en'));
  // }

  // useEffect(() => {
  //   let timeout: NodeJS.Timeout | null = null;
  //   const observer = new MutationObserver(() => {
  //     if (timeout) clearTimeout(timeout);
  //     timeout = setTimeout(() => {
  //       getCurrentGoogleTranslateLang();
  //     }, 200);
  //   });
  //   observer.observe(document.body, { childList: true, subtree: true });

  //   return () => {
  //     observer.disconnect();
  //     if (timeout) clearTimeout(timeout);
  //   };
  // }, []);

  return (
    <>
      <CacheBuster
        currentVersion={app.version}
        isEnabled={true}
        reloadOnDowngrade={true}
        isVerboseMode={true}
        loadingComponent={<Loader />}
        metaFileDirectory={'.'}
        onCacheClear={(refreshCacheAndReload: () => Promise<void>) => { }}
      >
        <>
          <Suspense fallback={<Loader />}>
            {!loader &&
              <Router>
                <UX4GAccessibilityWidget />
                {webOpen && <OtherWebLink />}
                <Components />
              </Router>
            }
          </Suspense>
        </>
      </CacheBuster>
    </>
  );
};

export default MainRouter;